import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Seo } from '@/components/Seo';
import Header from '@/components/Header';
import { ArrowLeft } from 'lucide-react';
import Footer from '@/components/Footer';
import { WidgetEmbed, parseConfig } from '@/components/widgets/WidgetEmbed';
import { WidgetConfigurator } from '@/components/widgets/WidgetConfigurator';

const SharePage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const isEmbed = searchParams.get('embed') === '1';
  const hasWidgetParams = searchParams.get('type') != null;

  if (isEmbed) {
    if (hasWidgetParams) {
      const config = parseConfig(searchParams);
      const pageBg = config.bgColor;
      return (
        <>
          <Seo title="Widget" noindex />
          <div
          className={`min-h-[460px] flex flex-col items-center justify-center p-3 sm:p-4 ${!pageBg ? 'bg-slate-50' : ''}`}
          style={pageBg ? { backgroundColor: pageBg } : undefined}
        >
          <div className="w-full max-w-xl">
            <WidgetEmbed config={config} baseUrl="/" />
          </div>
        </div>
        </>
      );
    }
    return (
      <>
        <Seo title="Widget" noindex />
        <div className="min-h-[200px] flex flex-col items-center justify-center p-6 bg-slate-50">
          <a href="/del" target="_blank" rel="noopener noreferrer" className="text-nordicBlue hover:underline">
            Lag widget på kommunaleavgifter.no
          </a>
        </div>
      </>
    );
  }

  return (
    <div className="min-h-screen flex flex-col bg-softWhite">
      <Seo
        title="Lag widget | Kommunale avgifter i Norge"
        description="Lag tilpassede widgeter: nøkkeltall, kommunesammenligning, fylkesoversikt, toppliste. Kopier iframe-kode for blogg eller nettside."
        path="/del"
      />
      <Header />
      <main className="flex-grow container mx-auto px-4 py-8">
        {/* Hero – samme kortstil som forsiden */}
        <div className="mb-8 py-6 px-5 md:px-6 rounded-2xl bg-gradient-to-br from-nordicBlue/5 to-transparent border border-nordicBlue/10">
          <nav className="flex items-center gap-2 text-sm text-warmGray mb-4">
            <Link to="/" className="flex items-center gap-1.5 hover:text-nordicBlue transition-colors">
            <ArrowLeft className="h-3.5 w-3.5" />
            Forside
          </Link>
            <span>/</span>
            <span className="text-nordicBlue font-semibold">Del</span>
          </nav>
          <h1 className="text-3xl md:text-4xl font-bold text-deepCharcoal mb-2">Lag egen widget</h1>
          <p className="text-warmGray">
            Lag widgeter du kan sette inn på blogg, nyhetsbrev eller nettside. Last opp forhåndsvisning og kopier koden.
          </p>
        </div>
        <WidgetConfigurator />
      </main>
      <Footer />
    </div>
  );
};

export default SharePage;
